import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./style.css";
import VueRecaptcha from "vue-recaptcha-v3";
import { createHead } from "@vueuse/head";

const app = createApp(App);

app.config.globalProperties.$API_BASEURL = "https://api.atlasimprov.com/";
app.config.globalProperties.$API_ASSETS = "https://api.atlasimprov.com/assets/";
app.config.globalProperties.$API_GRAPHQL =
  "https://api.atlasimprov.com/graphql/";
app.config.globalProperties.$TICKETS_URL =
  "https://atlasimprov.crowdwork.com/shows";
app.config.globalProperties.$PHONE_NO = "https://api.atlasimprov.com/graphql/";
app.config.globalProperties.$CLASS_URL =
  "https://atlasimprov.crowdwork.com/classes";
app.config.globalProperties.$FWBASE =
  "https://atlasimprov.crowdwork.com";

app.use(VueRecaptcha, { siteKey: "6LdnG1AqAAAAAA1soTEDyDTYwj0lexKCwP2fbCus" });

const head = createHead();
app.use(head);

const SITE_URL = "https://atlasimprov.com";
const DEFAULT_TITLE = "Atlas Improv – Improv Comedy Shows & Classes in Madison, WI";
const DEFAULT_DESCRIPTION = "Atlas Improv Co. performs every Friday and Saturday at 7 & 9 PM at 609 E Washington Ave., Madison, WI.";
const DEFAULT_OG_IMAGE = `${SITE_URL}/social_card_1200x630.png`;

function setMeta(attr, key, value) {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

router.afterEach((to) => {
  const title = (to.meta?.title || DEFAULT_TITLE).trim();
  const description = (to.meta?.description || DEFAULT_DESCRIPTION).trim();
  const url = `${SITE_URL}${to.fullPath}`;

  document.title = title;
  setMeta("name", "description", description);
  setLink("canonical", url);

  setMeta("property", "og:title", title);
  setMeta("property", "og:description", description);
  setMeta("property", "og:url", url);
  setMeta("property", "og:image", DEFAULT_OG_IMAGE);
  setMeta("property", "og:type", "website");

  setMeta("name", "twitter:title", title);
  setMeta("name", "twitter:description", description);
  setMeta("name", "twitter:card", "summary_large_image");
});

app.use(router);
app.use(store);
app.mount("#app");
